import login from './login.api'
import profile from './profile.api'
import register from './register.api'

export const auth = {
  login,
  profile,
  register,
}
